import { useState, useCallback } from "react";
/**
 * Uses boolean state with functions to open, close, and toggle.
 */
export function useDisclosure() {
  let {
    defaultIsOpen,
    onOpen,
    onClose
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [isOpen, setIsOpen] = useState(defaultIsOpen ?? false);
  const open = useCallback(() => {
    setIsOpen(true);
    onOpen?.();
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
    onClose?.();
  }, []);
  const toggle = useCallback(() => {
    const fn = isOpen ? close : open;
    fn();
  }, [isOpen, open, close]);
  return {
    isOpen,
    open,
    close,
    toggle
  };
}